import { ProfileFragment } from 'graphql/types'

export const getProfileLink = (profile: ProfileFragment) => {
  return `${window.location.host}/${profile.identifier}`
}
